import { GridDragAndDrop } from '../GridDragAndDropDndKit/GridDragAndDrop';
import { TableDragAndDrop } from '../TableDragAndDrop';

export const TableGridSwitchDragAndDrop = {
  grid: GridDragAndDrop,
  table: TableDragAndDrop,
};
